import Joi from "joi-browser";

import useConfigureForm from "../useConfigureForm";

export default useWaitForCallbackForm;

export const waitForCallbackConfigSchema = {
  name: Joi.string().required().label("Name"),
  callbackId: Joi.string().required().label("Callback ID"),
  description: Joi.string().allow(null, "").label("Description"),
  timeoutSeconds: Joi.number().required().label("Timeout Seconds"),
  expectedFields: Joi.array().label("Expected Fields"),
};

export function getWaitForCallbackConfigureData(waitForCallbackConfig) {
  const { name, description, callbackId, timeoutSeconds, expectedFields } =
    waitForCallbackConfig;

  return {
    name,
    description,
    callbackId,
    timeoutSeconds,
    expectedFields,
  };
}

function useWaitForCallbackForm(waitForCallbackConfig, validationErrors) {
  const { formState, updateFormState, validate, errors } = useConfigureForm(
    () => getWaitForCallbackConfigureData(waitForCallbackConfig),
    waitForCallbackConfigSchema,
    validationErrors,
  );

  return {
    formState,
    updateFormState,
    validate,
    errors,
  };
}
